export const Entity = {
  DEFAULT: "default",
  COMPUTED: "computed",
} as const;
